import Coffee from "../../images/9-Coffee beans.png";
import Automobiles from "../../images/Automobiles.png";
import Mining from "../../images/Mining.png";

const questionAnswers = [
  // Strawberry Questtions
  // Domestic Graph Questions
  // model A
  // {
  //   title: "Gasoline Market in India",
  //   type: "domestic",
  //   answer: [1],
  //   answerTextTop:
  //     "Question: The graph shows the strawberry market in equilibrium.",
  //   answerText:
  //     "The area under the demand curve and above the price represents the gains to consumers from trade (consumer surplus). It is the difference between the maximum price they are willing to pay for a given quantity and the market price they actually paid.",
  //   notQuiteText: "Not quite. You identified part, but not all of the consumer surplus.",
  //   header: "IN EQUILIBRIUM",
  //   mobileHeader: "IN EQUILIBRIUM",
  //   text: "The graph shows the strawberry market in equilibrium.",
  //   question: "CONSUMER SURPLUS",
  //   icon: Strawberry,
  // },
  // {
  //   title: "Gasoline Market in India",
  //   type: "domestic",
  //   answer: [5],
  //   answerTextTop:
  //     "Question: The graph shows the strawberry market in equilibrium.",
  //   answerText: "The area above the supply curve and below the price represents the gains from trade for producers (producer surplus). It is the difference between the price they were actually paid and the minimum price they would accept for a given quantity.",
  //   notQuiteText: "Not quite. You identified part, but not all of the producer surplus.",
  //   header: "IN EQUILIBRIUM",
  //   mobileHeader: "IN EQUILIBRIUM",
  //   text: "The graph shows the strawberry market in equilibrium.",
  //   question: "PRODUCER SURPLUS",
  //   icon: Strawberry,
  // },
  // {
  //   title: "Gasoline Market in India",
  //   type: "domestic",
  //   answer: [1, 5],
  //   answerTextTop:
  //     "Question: The graph shows the strawberry market in equilibrium.",
  //   answerText:
  //     "Total surplus is the sum of consumer surplus and producer surplus. Conceptually, the demand curve represents the value (or willingness to pay) for consumers, while the supply curve represents producers' costs. Total surplus is created because buyers value the strawberries more than it costs sellers to produce them.	",
  //   notQuiteText: "Not quite. You identified part, but not all of the total surplus.",
  //   header: "IN EQUILIBRIUM",
  //   mobileHeader: "IN EQUILIBRIUM",
  //   text: "The graph shows the strawberry market in equilibrium.",
  //   question: "TOTAL SURPLUS",
  //   icon: Strawberry,
  // },
  // {
  //   title: "Gasoline Market in India",
  //   type: "domestic",
  //   answer: [],
  //   answerTextTop:
  //     "Question: The graph shows the strawberry market in equilibrium.",
  //   answerText:
  //     "The deadweight loss is the reduction in the total surplus when the market is not in equilibrium. There is no deadweight loss at the equilibrium price P<sub>0</sub>.",
  //   notQuiteText: "",
  //   header: "IN EQUILIBRIUM",
  //   mobileHeader: "IN EQUILIBRIUM",
  //   text: "The graph shows the strawberry market in equilibrium.",
  //   question: "DEADWEIGHT LOSS",
  //   icon: Strawberry,
  // },

// International Graph Questions
  // [2, 5, 51, 21, 22, 6, 7]
  // A=2, B=21, C=22, D=5, E=51, F=6, G=7, H=8
  // model C
  {
    title: "Coffee Market in Colombia",
    type: "international",
    answer: [2,21,22],
    answerTextTop:
      'Question: The graph shows the market for coffee in Colombia. The Colombian government decides to impose a price floor on coffee (labeled "P floor") which is below the market price.',
    answerText:
      "When the price floor is below the equilibrium (market) price, any price above the price floor is legal. Therefore, the market is in equilibrium and the price of coffee is P<sub>o</sub>. The consumer surplus is the area below the demand curve and above the price P<sub>o</sub>.",
    notQuiteText: "Not quite. You identified part, but not all of the consumer surplus.",
    header: "IN EQUILIBRIUM",
    mobileHeader: "IN EQUILIBRIUM",
    text: 'The graph shows the market for coffee in Colombia. The Colombian government decides to impose a price floor on coffee (labeled "P floor") which is below the market price.',
    question: "CONSUMER SURPLUS",
    icon: Coffee,
  },
  {
    title: "Coffee Market in Colombia",
    type: "international",
    answer: [5,51,8],
    answerTextTop:
    'Question: The graph shows the market for coffee in Colombia. The Colombian government decides to impose a price floor on coffee (labeled "P floor") which is below the market price.',
    answerText: "When the price floor is below the equilibrium (market) price, any price above the price floor is legal. Therefore, the market is in equilibrium and the price of coffee is P<sub>o</sub>. The producer surplus is the area above the supply curve and below the price P<sub>o</sub>.",
    notQuiteText: "Not quite. You identified part, but not all of the producer surplus.",
    header: "IN EQUILIBRIUM",
    mobileHeader: "IN EQUILIBRIUM",
    text: 'The graph shows the market for coffee in Colombia. The Colombian government decides to impose a price floor on coffee (labeled "P floor") which is below the market price.',
    question: "PRODUCER SURPLUS",
    icon: Coffee,
  },
  {
    title: "Coffee Market in Colombia",
    type: "international",
    answer: [2,21,22,5,51,8],
    answerTextTop:
    'Question: The graph shows the market for coffee in Colombia. The Colombian government decides to impose a price floor on coffee (labeled "P floor") which is below the market price.',
    answerText:
      "Total surplus is the sum of consumer surplus and producer surplus. Conceptually, the demand curve represents the value (or willingness to pay) for consumers, while the supply curve represents producers' marginal costs. Total surplus is created because buyers value the coffee more than it costs sellers to produce it.",
    notQuiteText: "Not quite. You identified part, but not all of the total surplus.",
    header: "IN EQUILIBRIUM",
    mobileHeader: "IN EQUILIBRIUM",
    text: 'The graph shows the market for coffee in Colombia. The Colombian government decides to impose a price floor on coffee (labeled "P floor") which is below the market price.',
    question: "TOTAL SURPLUS",
    icon: Coffee,
  },
  {
    title: "Coffee Market in Colombia",
    type: "international",
    answer: [],
    answerTextTop:
    'Question: The graph shows the market for coffee in Colombia. The Colombian government decides to impose a price floor on coffee (labeled "P floor") which is below the market price.',
    answerText:
      "The deadweight loss is the reduction in the total surplus when the market is not in equilibrium. There is no deadweight loss at the equilibrium price P<sub>0</sub>.",
    notQuiteText: "",
    header: "IN EQUILIBRIUM",
    mobileHeader: "IN EQUILIBRIUM",
    text: 'The graph shows the market for coffee in Colombia. The Colombian government decides to impose a price floor on coffee (labeled "P floor") which is below the market price.',
    question: "DEADWEIGHT LOSS",
    icon: Coffee,
  },

  // international 2
  // A=2, B=4, C=5, D=6, E=9, F=10
  // model B
  {
    title: "Coffee Market in Colombia",
    type: "international2",
    answer: [2], //3A
    answerTextTop:
      'Question: The graph shows the market for coffee in Colombia. The Colombian government decides to impose a price floor on coffee (labeled "P floor") which is above the market price.',
    answerText:
      "When the price floor is above the equilibrium (market) price, the price of coffee equals the price floor. At this price, the quantity demanded would be lower than the quantity supplied, so the quantity of coffee bought and sold would be the smaller of the two quantities, i.e., Q<sub>1</sub>. The consumer surplus is the area above the price ceiling and below the demand curve, restricted by the quantity demanded Q<sub>1</sub>.",
    notQuiteText: "Not quite. You identified part, but not all of the consumer surplus.",
    header: "NOT IN EQUILIBRIUM",
    mobileHeader: "NOT IN EQUILIBRIUM",
    text: 'The graph shows the market for coffee in Colombia. The Colombian government decides to impose a price floor on coffee (labeled "P floor") which is above the market price.',
    question: "CONSUMER SURPLUS",
    icon: Coffee,
  },
  {
    title: "Coffee Market in Colombia",
    type: "international2",
    answer: [4,9],
    answerTextTop:
    'Question: The graph shows the market for coffee in Colombia. The Colombian government decides to impose a price floor on coffee (labeled "P floor") which is above the market price.',
    answerText: "When the price floor is above the equilibrium (market) price, the price of coffee equals the price floor. At this price, the quantity demanded would be lower than the quantity supplied, so the quantity of coffee bought and sold would be the smaller of the two quantities, i.e., Q<sub>1</sub>. The producer surplus is the area above the supply curve and below the price (P floor), restricted by the quantity demanded Q<sub>1</sub>.",
    notQuiteText: "Not quite. You identified part, but not all of the producer surplus.",
    header: "NOT IN EQUILIBRIUM",
    mobileHeader: "NOT IN EQUILIBRIUM",
    text: 'The graph shows the market for coffee in Colombia. The Colombian government decides to impose a price floor on coffee (labeled "P floor") which is above the market price.',
    question: "PRODUCER SURPLUS",
    icon: Coffee,
  },
  {
    title: "Coffee Market in Colombia",
    type: "international2",
    answer: [2,4,9],
    answerTextTop:
    'Question: The graph shows the market for coffee in Colombia. The Colombian government decides to impose a price floor on coffee (labeled "P floor") which is above the market price.',
    answerText:
      "Total surplus is the sum of consumer surplus and producer surplus.",
    notQuiteText: "Not quite. You identified part, but not all of the total surplus.",
    header: "NOT IN EQUILIBRIUM",
    mobileHeader: "NOT IN EQUILIBRIUM",
    // text: "The graph shows the market for strawberries in the U.S. Suppose that the market is not in equilibrium, and the price of strawberries is P<sub>1</sub>, a price higher than the equilibrium price P<sub>0</sub>.",
    text: 'The graph shows the market for coffee in Colombia. The Colombian government decides to impose a price floor on coffee (labeled "P floor") which is above the market price.',

    question: "TOTAL SURPLUS",
    icon: Coffee,
  },
  {
    title: "Coffee Market in Colombia",
    type: "international2",
    answer: [5,10],
    answerTextTop:
    'Question: The graph shows the market for coffee in Colombia. The Colombian government decides to impose a price floor on coffee (labeled "P floor") which is above the market price.',
    answerText: "The deadweight loss is the reduction in the total surplus when the market is not in equilibrium. This is found by subtracting the total surplus area at quantity Q<sub>1</sub> from the area at quantity Q<sub>0</sub>.",
    notQuiteText: "",
    header: "NOT IN EQUILIBRIUM",
    mobileHeader: "NOT IN EQUILIBRIUM",
    text: 'The graph shows the market for coffee in Colombia. The Colombian government decides to impose a price floor on coffee (labeled "P floor") which is above the market price.',
    question: "DEADWEIGHT LOSS",
    icon: Coffee,
  },

  // {
  //   title: "U.S. Strawberry Market",
  //   type: "international",
  //   answer: [8],
  //   answerTextTop:
  //     "Q. The U.S. is now able to import avocados from other countries at a lower price than the U.S. market price.",
  //   answerText:
  //     "The triangle shows the producer surplus area, the amount that producers get above the minimum they would have accepted. Since the price has decreased, producer surplus decreases.",
  //   notQuiteText: "",
  //   header: "NOT IN EQUILIBRIUM",
  //   mobileHeader: "NOT IN EQUILIBRIUM",
  //   text: "The U.S. is now able to import avocados from other countries at a lower price than the U.S. market price. The world supply curve is labeled “S<sub>w</sub>” and the domestic supply curve is labeled “S<sub>d</sub>”  on the graph.",
  //   question: "DOMESTIC PRODUCER SURPLUS",
  //   icon: Avocado,
  // },
  // {
  //   title: "U.S. Strawberry Market",
  //   type: "international",
  //   answer: [2, 5, 6, 7, 8],
  //   answerTextTop:
  //     "Q. The U.S. is now able to import avocados from other countries at a lower price than the U.S. market price.",
  //   answerText:
  //     "Total surplus is simply the sum of consumer surplus and producer surplus.",
  //   notQuiteText:
  //     "Not quite. You identified part, but not all of the total surplus from international trade.",
  //   header: "NOT IN EQUILIBRIUM",
  //   mobileHeader: "NOT IN EQUILIBRIUM",
  //   text: "The U.S. is now able to import avocados from other countries at a lower price than the U.S. market price. The world supply curve is labeled “S<sub>w</sub>” and the domestic supply curve is labeled “S<sub>d</sub>”  on the graph.",
  //   question: "TOTAL SURPLUS",
  //   icon: Avocado,
  // },
  // {
  //   title: "U.S. Strawberry Market",
  //   type: "international",
  //   answer: [6, 7],
  //   answerTextTop:
  //     "Q. The U.S. is now able to import avocados from other countries at a lower price than the U.S. market price.",
  //   answerText:
  //     "The triangle shows all of the additional (net) gains created by trading with more efficient avocado producers.",
  //   notQuiteText:
  //     "Not quite. You identified part, but not all of the net gains from international trade.",
  //   header: "NOT IN EQUILIBRIUM",
  //   mobileHeader: "NOT IN EQUILIBRIUM",
  //   text: "The U.S. is now able to import avocados from other countries at a lower price than the U.S. market price. The world supply curve is labeled “S<sub>w</sub>” and the domestic supply curve is labeled “S<sub>d</sub>”  on the graph.",
  //   question: "GAINS FROM INTERNATIONAL TRADE",
  //   icon: Avocado,
  // },

  // US Mining Equipment
  // Domestic
  // {
  //   title: "U.S. Strawberry Market",
  //   type: "domestic",
  //   answer: [1], //1A
  //   answerTextTop:
  //     "Q. U.S. suppliers are able to sell mining equipment only in the U.S",
  //   answerText:
  //     "The area under the demand curve and above the price represents the gains to consumers from trade. It is the difference between the maximum price they would have been willing to pay for a given quantity and the market price the consumer actually had to pay.",
  //   notQuiteText: "",
  //   header: "IN EQUILIBRIUM",
  //   mobileHeader: "IN EQUILIBRIUM",
  //   text: "U.S. suppliers are able to sell mining equipment only in the U.S.",
  //   question: "CONSUMER SURPLUS",
  //   icon: Mining,
  // },

  // {
  //   title: "U.S. Strawberry Market",
  //   type: "domestic",
  //   answer: [5], // 1B
  //   answerTextTop:
  //     "Q. U.S. suppliers are able to sell mining equipment only in the U.S.",
  //   answerText:
  //     "The area above the supply curve and below the price represents the gains from trade for producers. It is the difference between the minimum price they would have accepted for a given quantity and the price they were actually paid.",
  //   notQuiteText: "",
  //   header: "IN EQUILIBRIUM",
  //   mobileHeader: "IN EQUILIBRIUM",
  //   text: "U.S. suppliers are able to sell mining equipment only in the U.S.",
  //   question: "PRODUCER SURPLUS",
  //   icon: Mining,
  // },

  // {
  //   title: "U.S. Strawberry Market",
  //   type: "domestic",
  //   answer: [1, 5], //1A,1B
  //   answerTextTop:
  //     "Q. Only U.S. suppliers are able to sell mining equipment in the U.S.",
  //   answerText:
  //     "Total surplus is simply the sum of consumer surplus and producer surplus.",
  //   notQuiteText:
  //     "Not quite. You identified part, but not all of the total surplus from domestic trade.",
  //   header: "IN EQUILIBRIUM",
  //   mobileHeader: "IN EQUILIBRIUM",
  //   text: "Only U.S. suppliers are able to sell mining equipment in the U.S.",
  //   question: "TOTAL SURPLUS",
  //   icon: Mining,
  // },

  // international 2

  // {
  //   title: "U.S. Strawberry Market",
  //   type: "international2",
  //   answer: [2], //3A
  //   answerTextTop:
  //     "Q. International trade is now allowed. The world price for mining equipment is higher than the U.S. price, so U.S. suppliers export their equipment to other countries.",
  //   answerText:
  //     "Unlike the avocados, the U.S. suppliers have a comparative advantage. Consumer surplus shrinks to the triangle shown. This is because domestic consumers now pay a higher price for mining equipment.",
  //   notQuiteText: "",
  //   header: "NOT IN EQUILIBRIUM",
  //   mobileHeader: "NOT IN EQUILIBRIUM",
  //   text: "International trade is now allowed. The world price for mining equipment is higher than the U.S. price, so U.S. suppliers now export their equipment to other countries. The world supply curve is labeled “S<sub>w</sub>” and the domestic supply curve is labeled “S<sub>d</sub>” on the graph.",
  //   question: "DOMESTIC CONSUMER SURPLUS",
  //   icon: Mining,
  // },

  // {
  //   title: "U.S. Strawberry Market",
  //   type: "international2",
  //   answer: [4, 5, 6, 9, 10], //3B,3C,3D,3E,3F
  //   answerTextTop:
  //     "Q. International trade is now allowed. The world price for mining equipment is higher than the U.S. price, so U.S. suppliers export their equipment to other countries.",
  //   answerText:
  //     "Unlike the avocados, the U.S. suppliers have a comparative advantage. The triangle shows the producer surplus area, the amount that producers get above the minimum they would have accepted. Since the price has increased, producer surplus goes up.",
  //   notQuiteText:
  //     "Not quite. You identified part, but not all of the domestic producer surplus from domestic trade.",
  //   header: "NOT IN EQUILIBRIUM",
  //   mobileHeader: "NOT IN EQUILIBRIUM",
  //   text: "International trade is now allowed. The world price for mining equipment is higher than the U.S. price, so U.S. suppliers now export their equipment to other countries. The world supply curve is labeled “S<sub>w</sub>” and the domestic supply curve is labeled “S<sub>d</sub>” on the graph.",
  //   question: "DOMESTIC PRODUCER SURPLUS",
  //   icon: Mining,
  // },

  // {
  //   title: "U.S. Strawberry Market",
  //   type: "international2",
  //   answer: [2, 4, 5, 6, 9, 10], //3A,3B,3C,3D,3E,3F
  //   answerTextTop:
  //     "Q. International trade is now allowed. The world price for mining equipment is higher than the U.S. price, so U.S. suppliers export their equipment to other countries.",
  //   answerText:
  //     "Total surplus is simply the sum of consumer surplus and producer surplus.",
  //   notQuiteText:
  //     "Not quite. You identified part, but not all of total surplus from international trade",
  //   header: "NOT IN EQUILIBRIUM",
  //   text: "International trade is now allowed. The world price for mining equipment is higher than the U.S. price, so U.S. suppliers now export their equipment to other countries. The world supply curve is labeled “S<sub>w</sub>” and the domestic supply curve is labeled “S<sub>d</sub>” on the graph.",
  //   question: "TOTAL SURPLUS",
  //   icon: Mining,
  // },

  // {
  //   title: "U.S. Strawberry Market",
  //   type: "international2",
  //   answer: [6], //3D
  //   answerTextTop:
  //     "Q. International trade is now allowed. The world price for mining equipment is higher than the U.S. price, so U.S. suppliers export their equipment to other countries.",
  //   answerText:
  //     "The triangle shows all of the additional (net) gains created by trading with more efficient mining equipment producers.",
  //   notQuiteText: "",
  //   header: "NOT IN EQUILIBRIUM",
  //   text: "International trade is now allowed. The world price for mining equipment is higher than the U.S. price, so U.S. suppliers now export their equipment to other countries. The world supply curve is labeled “S<sub>w</sub>” and the domestic supply curve is labeled “S<sub>d</sub>” on the graph.",
  //   question: "GAINS FROM INTERNATIONAL TRADE",
  //   icon: Mining,
  // },

  // //AutoMobiles
  // //Domestic
  // {
  //   title: "U.S. Automobile Market",
  //   type: "domestic",
  //   answer: [5],
  //   answerTextTop:
  //     "Q. Only U.S. suppliers are able to sell automobiles in the U.S.",
  //   answerText:
  //     "The area above the supply curve and below the price represents the gains from trade for producers. It is the difference between the minimum price they would have accepted for a given quantity and the price they were actually paid.",
  //   notQuiteText: "",
  //   header: "IN EQUILIBRIUM",
  //   mobileHeader: "IN EQUILIBRIUM",
  //   text: "Only U.S. suppliers are able to sell automobiles in the U.S.",
  //   question: "PRODUCER SURPLUS",
  //   icon: Automobiles,
  // },

  // {
  //   title: "U.S. Automobile Market",
  //   type: "domestic",
  //   answer: [1],
  //   answerTextTop:
  //     "Q. Only U.S. suppliers are able to sell automobiles in the U.S.",
  //   answerText:
  //     "The area under the demand curve and above the price represents the gains to consumers from trade. It is the difference between the maximum price they would have been willing to pay for a given quantity and the market price the consumer actually had to pay.",
  //   notQuiteText: "",
  //   header: "IN EQUILIBRIUM",
  //   mobileHeader: "IN EQUILIBRIUM",
  //   text: "Only U.S. suppliers are able to sell automobiles in the U.S.",
  //   question: "CONSUMER SURPLUS",
  //   icon: Automobiles,
  // },

  // {
  //   title: "U.S. Automobile Market",
  //   type: "domestic",
  //   answer: [1, 5],
  //   answerTextTop:
  //     "Q. Only U.S. suppliers are able to sell automobiles in the U.S.",
  //   answerText:
  //     "Total surplus is simply the sum of consumer surplus and producer surplus.",
  //   notQuiteText:
  //     "Not quite. You identified part, but not all of the total surplus from domestic trade.",
  //   header: "IN EQUILIBRIUM",
  //   mobileHeader: "IN EQUILIBRIUM",
  //   text: "Only U.S. suppliers are able to sell automobiles in the U.S.",
  //   question: "TOTAL SURPLUS",
  //   icon: Automobiles,
  // },

  // //international
  // {
  //   title: "U.S. Automobile Market",
  //   type: "international",
  //   answer: [8],
  //   answerTextTop:
  //     "Q. The U.S. is now able to import automobiles from other countries at a lower price than the U.S. market price.",
  //   answerText:
  //     "The triangle shows the producer surplus area, the amount that producers get above the minimum they would have accepted. Since the price has decreased, producer surplus decreases.",
  //   notQuiteText: "",
  //   header: "NOT IN EQUILIBRIUM",
  //   mobileHeader: "NOT IN EQUILIBRIUM",
  //   text: "The U.S. is now able to import automobiles from other countries at a lower price than the U.S. market price. The world supply curve is labeled “S<sub>w</sub>”and the domestic supply curve is labeled “S<sub>d</sub>” on the graph.",
  //   question: "DOMESTIC PRODUCER SURPLUS",
  //   icon: Automobiles,
  // },

  // {
  //   title: "U.S. Automobile Market",
  //   type: "international",
  //   answer: [2, 5, 6, 7],
  //   answerTextTop:
  //     "Q. The U.S. is now able to import automobiles from other countries at a lower price than the U.S. market price.",
  //   answerText:
  //     "Consumer surplus expands to the large triangle shown. This expansion is a result of the new, lower price of automobiles.",
  //   notQuiteText:
  //     "Not quite. You identified part, but not all of consumer surplus.",
  //   header: "NOT IN EQUILIBRIUM",
  //   mobileHeader: "NOT IN EQUILIBRIUM",

  //   text: "The U.S. is now able to import automobiles from other countries at a lower price than the U.S. market price. The world supply curve is labeled “S<sub>w</sub>” and the domestic supply curve is labeled “S<sub>d</sub>” on the graph.",
  //   question: "DOMESTIC CONSUMER SURPLUS",
  //   icon: Automobiles,
  // },

  // {
  //   title: "U.S. Automobile Market",
  //   type: "international",
  //   answer: [2, 5, 6, 7, 8],
  //   answerTextTop:
  //     "Q. The U.S. is now able to import automobiles from other countries at a lower price than the U.S. market price.",
  //   answerText:
  //     "Total surplus is simply the sum of consumer surplus and producer surplus.",
  //   notQuiteText:
  //     "Not quite. You identified part, but not all of total surplus from international trade.",
  //   header: "NOT IN EQUILIBRIUM",
  //   mobileHeader: "NOT IN EQUILIBRIUM",
  //   text: "The U.S. is now able to import automobiles from other countries at a lower price than the U.S. market price. The world supply curve is labeled “S<sub>w</sub>” and the domestic supply curve is labeled “S<sub>d</sub>” on the graph.",
  //   question: "TOTAL SURPLUS",
  //   icon: Automobiles,
  // },

  // {
  //   title: "U.S. Automobile Market",
  //   type: "international",
  //   answer: [6, 7],
  //   answerTextTop:
  //     "Q. The U.S. is now able to import automobiles from other countries at a lower price than the U.S. market price.",
  //   answerText:
  //     "The triangle shows all of the additional (net) gains created by trading with more efficient automobile producers.",
  //   notQuiteText:
  //     "Not quite. You identified part, but not all of the net gains from international trade.",
  //   header: "NOT IN EQUILIBRIUM",
  //   mobileHeader: "NOT IN EQUILIBRIUM",
  //   text: "The U.S. is now able to import automobiles from other countries at a lower price than the U.S. market price. The world supply curve is labeled “S<sub>w</sub>” and the domestic supply curve is labeled “S<sub>d</sub>” on the graph.",
  //   question: "GAINS FROM INTERNATIONAL TRADE",
  //   icon: Automobiles,
  // },

  //8, 16 row conflicting answer top text and question
];

export default questionAnswers;
